// Shared accents for the operator node categories (same pattern as
// eventsTheme.js / cameraTheme.js: category color encodes category, defined once
// so EventGraph.jsx's palette entries and the node bodies read ONE source
// instead of each hardcoding the literal). Lives under src/components/nodes/,
// the functional-color exemption in tests/unit/paletteEnforcement.test.mjs.
export const COMPARISON_ACCENT = '#40c0b0'  // teal   — Comparison Operators
export const LOGICAL_ACCENT     = '#e0a040'  // amber  — Logical Operators
export const MATH_ACCENT        = '#a878e0'  // violet — Math Operators
